module.exports = __webpack_public_path__ + "img/Social-02.c8bc6088.png";